<ng-container>
  <ion-grid>
    <ion-row class="container">
      @for (item of contenData; track $index) { @if (!managView && item.state
      === 2 && item.public) { } @else {
      <ion-col size="12" sizeMd="6" sizeLg="4">
        <app-content-item [content]="item" [managView]="managView" />
      </ion-col>
      } } @if(contenData && contenData.length < 1) {
      <ion-col>
        <app-general-error type="warning" code="no-data.content"
      /></ion-col>
      }
    </ion-row>
  </ion-grid>
</ng-container>
